import {Report} from "../types/Report";

export const isSearchConsoleConfigured = (report: Report): boolean => {
    return report.integrations.google.is_connected && report.integrations.google.search_console.property_domain !== null && report.enable_gsc_rankings;
}